module.exports = __webpack_public_path__ + "static/media/SofiaProSemiBoldItalic.86bfad65.otf";